import { createPinia } from 'pinia';
import useAppStore from './modules/app';
import useUserStore from './modules/user';
import useDrawerStore from './modules/drawer';

const pinia = createPinia();

export { useAppStore, useUserStore, useDrawerStore };
export default pinia;
